// src/components/Tags/Styles/AddTagDialog.Style.js
// @flow

import { phoneInputCss } from '../../../css/phoneInput';

// MUI v5 style approach: we export an object whose values are
// (theme) => ({ ...styleProps }) so we can use them with `sx={...}`.

const addTagDialogStyles = {
  dialogFormCtr: (theme) => ({
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    '&.xlarge': {
      maxHeight: 400
    },
    '&.large': {
      maxHeight: 350
    }
  }),

  flexContainer: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  }),

  grow: (theme) => ({
    flexGrow: 1
  }),

  secondInput: (theme) => ({
    marginTop: theme.spacing(2)
  }),

  largeTextField: (theme) => ({
    '& label': {
      transform: 'translate(20px, 24px) scale(1)'
    },
    '& textarea': {
      padding: theme.spacing(1)
    }
  }),

  messageTenantDialogTitle: (theme) => ({
    fontSize: '1rem',
    padding: '24px 24px 8px 24px'
  }),

  textFieldCaptionRight: (theme) => ({
    textAlign: 'right',
    color: theme.palette.primary.light,
    fontSize: '0.8rem',
    position: 'absolute',
    bottom: 20,
    right: 42
  }),

  warning: (theme) => ({
    color: theme.palette.error.main
  }),
  error: (theme) => ({
    color: theme.palette.status.error.main
  }),

  phoneInputCtr: (theme) => ({
    ...phoneInputCss
  }),

  colorPickerRainbow: (theme) => ({
    background: 'conic-gradient(red, yellow, lime, aqua, blue, magenta, red)',
    width: theme.spacing(3),
    height: theme.spacing(3),
    borderRadius: theme.spacing(3),
    cursor: 'pointer',
    position: 'relative'
  }),

  popperCtr: (theme) => ({
    zIndex: 9999,
    top: '12px !important',
    left: '116px !important',
    [theme.breakpoints.down('xs')]: {
      left: '32px !important'
    }
  }),

  margin: (theme) => ({
    marginTop: theme.spacing(3)
  })
};

export default addTagDialogStyles;